import {LocalizedValue} from '@models/Projects/extProfils';

export const userRolesTypes =
  [
    'SURVEY_IDEA',
    'SURVEY_COMBAT',
    'SURVEY_BENCHMARK',
    'SURVEY_MULTI',
    'SURVEY_KANO',
    'SURVEY_EXCEL_EXPORT',
    'BLOG_ADD',
    'BLOG_STARS',
    'SUPER_USER',
    'SUPER_USER_5',
    'CHANGE_USER_LEVEL',
    'LOGIN_AS_USER',
    'PROJECT_MONETISATION',
    'SURVEY_MONETISATION',
    'PROJECT_ADD',
    'PROJECT_FILES',
    'AFFILIATE_RESPONDENT',
    'AFFILIATE_RECRUITMENT',
    'VIEW_EMAIL',
    'VIEW_URL_INVITATION',
    'VIEW_URL_INVITATION_ALL',
    'VIEW_METHO_INBE',
    'USECASE',
    'EXPERT_INTERACTION',
    'CAN_BUY_CREDITS',
    'STARTER_ACCOUNT',
    'BASIC_ACCOUNT',
    'PRO_ACCOUNT',
    'PROPLUS_ACCOUNT',
    'ADVANCEJOINPROJECT',
    'COMMUNITY',
    'COMMUNITY_INTERACTION',
    'CAN_PUBLISH',
    'PUBLIC_COMMUNITY_CREATION',
    'SEND_EMAIL_COMMUNITY',
    'COMMUNITY_FRONTPAGE',
    'DISPLAY_SIDEBAR',
    'SAAS_PUBLICATION',
    'NO_PROFORMAT',
    'MODE_PUBLICATION',
    'RESULT_PPT',
    'RESULT_PPT_PRO',
    'SURVEY_DETAIL_RESULT_VIEW',
    'GET_ALL_EXT_PROFILS',
    'ANNOTATION_READ',
    'ANNOTATION_WRITE',
    'SURVEY_STATS',
    'DETAIL_RESPONSES',
    'SAAS_LIST',
    'GOD_MODE',
    'PUBLIC_LINK',
    'MULTI_ANNOTATE',
    'MULTI_CONDITIONS',
    'SHORTCUT_TO_V2',
    'V2_PUBLICATION',
    'V2_RESULT_DASHBOARD',
    'V2_DETAILED_RESPONSES',
    'V2_QUALITY_CONTROL',
    'V2_QUALITY_CONTROL_AI',
    'V2_SURVEY_DUPLICATION',
    'PREVIEW_SURVEY',
    'MANAGE_COMMUNITIES',
    'MANAGE_PROJECTS',
    'MANAGE_PUBLICATIONS',
    'MANAGE_ALL_TEMPLATES',
    'SURVEY_TEMPLATE_ADD',
    'CAN_EDIT_SURVEY_DIRECT',
    'PUBLICATIONS_GENERATE_LINKS',
    'SURVEY_MODE_TEST',
    'TRANSCRIBE',
    'TRANSCRIBE_CHOOSE_ENGINE',
    'TRANSCRIBE_REGENERATE',
    'doNotEvaluateGodMode',
    'ORG_DASH',
    'ORG_DASH_EDIT',
    'ORG_DASH_BACKUP',
    'ORG_DASH_PUBLIC',
    'ASK_AI_ASSISTANT',
    'ASK_AI_THREAD',
    'ASK_AI_STD_PROMPT'
  ] as const;
export type userRoles = typeof userRolesTypes[number];

export interface IUserRolesDetail {
  key: string;
  caption: LocalizedValue;
  legacy: boolean;
}


export const userRolesDetails: Record<userRoles, IUserRolesDetail> = {
  SURVEY_IDEA: {
    key: 'SURVEY_IDEA',
    caption: {
      fr: 'Droit de faire un questionnaire chasse aus idées'
    },
    legacy: true
  },
  SURVEY_COMBAT: {
    key: 'SURVEY_COMBAT',
    caption: {
      fr: 'Droit de faire un questionnaire combat d\'idées'
    },
    legacy: true
  },
  SURVEY_BENCHMARK: {
    key: 'SURVEY_BENCHMARK',
    caption: {
      fr: 'Droit de faire un questionnaire de type Benchmark'
    },
    legacy: true
  },
  SURVEY_MULTI: {
    key: 'SURVEY_MULTI',
    caption: {
      fr: 'Droit de faire un questionnaire de type Multi'
    },
    legacy: true
  },
  SURVEY_KANO: {
    key: 'SURVEY_KANO',
    caption: {
      fr: 'Droit de faire un questionnaire de type KANO'
    },
    legacy: true
  },
  SURVEY_EXCEL_EXPORT: {
    key: 'SURVEY_EXCEL_EXPORT',
    caption: {
      fr: 'Droit d\'exporter les résultats en format excel'
    },
    legacy: true
  },
  BLOG_ADD: {
    key: 'BLOG_ADD',
    caption: {
      fr: 'Droit d\'ajouter un article'
    },
    legacy: true
  },
  BLOG_STARS: {
    key: 'BLOG_STARS',
    caption: {
      fr: 'BLOG_STARS'
    },
    legacy: true
  },
  SUPER_USER: {
    key: 'SUPER_USER',
    caption: {
      fr: 'Droit de faire des super-utilisateur'
    },
    legacy: true
  },
  SUPER_USER_5: {
    key: 'SUPER_USER_5',
    caption: {
      fr: '5 super-utilisateur max'
    },
    legacy: true
  },
  CHANGE_USER_LEVEL: {
    key: 'CHANGE_USER_LEVEL',
    caption: {
      fr: 'CHANGE_USER_LEVEL'
    },
    legacy: true
  },
  LOGIN_AS_USER: {
    key: 'LOGIN_AS_USER',
    caption: {
      fr: 'Possibilité de se connecter avec un utilisateur'
    },
    legacy: true
  },
  PROJECT_MONETISATION: {
    key: 'PROJECT_MONETISATION',
    caption: {
      fr: 'Droit de monétiser les questionnaires'
    },
    legacy: true
  },
  SURVEY_MONETISATION: {
    key: 'SURVEY_MONETISATION',
    caption: {
      fr: 'Affiche l\'ongleut pour paramétrer la monétisation dans un questionnaire (cas Exceldor)'
    },
    legacy: true
  },
  PROJECT_ADD: {
    key: 'PROJECT_ADD',
    caption: {
      fr: 'Droit de pouvoir créer d\'autres projets'
    },
    legacy: true
  },
  PROJECT_FILES: {
    key: 'PROJECT_FILES',
    caption: {
      fr: 'Explorateur de fichiers'
    },
    legacy: true
  },
  AFFILIATE_RESPONDENT: {
    key: 'AFFILIATE_RESPONDENT',
    caption: {
      fr: 'Droits de répondre pour des clients'
    },
    legacy: true
  },
  AFFILIATE_RECRUITMENT: {
    key: 'AFFILIATE_RECRUITMENT',
    caption: {
      fr: 'Droits de promouvoir une communauté auprès des recruteurs'
    },
    legacy: true
  },
  VIEW_EMAIL: {
    key: 'VIEW_EMAIL',
    caption: {
      fr: 'Droits de voir les courriels'
    },
    legacy: true
  },
  VIEW_URL_INVITATION: {
    key: 'VIEW_URL_INVITATION',
    caption: {
      fr: 'Voir les URL d\'invitation d\'un utilisateur du projet courant'
    },
    legacy: true
  },
  VIEW_URL_INVITATION_ALL: {
    key: 'VIEW_URL_INVITATION_ALL',
    caption: {
      fr: 'Voir les URL d\'invitation d\'un utilisateur de TOUS les projets'
    },
    legacy: true
  },
  VIEW_METHO_INBE: {
    key: 'VIEW_METHO_INBE',
    caption: {
      fr: 'Voir la methodologie Inbe - astuces et aide en ligne'
    },
    legacy: true
  },
  USECASE: {
    key: 'USECASE',
    caption: {
      fr: 'Possibilité d\'avoir des cas d\'usage'
    },
    legacy: true
  },
  EXPERT_INTERACTION: {
    key: 'EXPERT_INTERACTION',
    caption: {
      fr: 'Possibilité d\'interagir avec les experts (Blogs, appel d\'offre)'
    },
    legacy: true
  },
  CAN_BUY_CREDITS: {
    key: 'CAN_BUY_CREDITS',
    caption: {
      fr: 'Possibilité d\'acheter des nouveaux crédits (Carte de crédit)'
    },
    legacy: true
  },
  STARTER_ACCOUNT: {
    key: 'STARTER_ACCOUNT',
    caption: {
      fr: 'Compte Starter'
    },
    legacy: true
  },
  BASIC_ACCOUNT: {
    key: 'BASIC_ACCOUNT',
    caption: {
      fr: 'Compte Basic'
    },
    legacy: true
  },
  PRO_ACCOUNT: {
    key: 'PRO_ACCOUNT',
    caption: {
      fr: 'Compte Pro'
    },
    legacy: true
  },
  PROPLUS_ACCOUNT: {
    key: 'PROPLUS_ACCOUNT',
    caption: {
      fr: 'Compte Pro+'
    },
    legacy: true
  },
  ADVANCEJOINPROJECT: {
    key: 'ADVANCEJOINPROJECT',
    caption: {
      fr: 'Edition avancée des pages de communauté'
    },
    legacy: true
  },
  COMMUNITY: {
    key: 'COMMUNITY',
    caption: {
      fr: 'Rôle communauté'
    },
    legacy: true
  },
  COMMUNITY_INTERACTION: {
    key: 'COMMUNITY_INTERACTION',
    caption: {
      fr: 'Empêche toute interaction avec les participants - email, publication de questionnaire (cas demo).'
    },
    legacy: true
  },
  CAN_PUBLISH: {
    key: 'CAN_PUBLISH',
    caption: {
      fr: 'Permet de publier (dernier écran des questionnaires + nouveau des publications.'
    },
    legacy: true
  },
  PUBLIC_COMMUNITY_CREATION: {
    key: 'PUBLIC_COMMUNITY_CREATION',
    caption: {
      fr: 'Possibilité de créer des communautés publiques'
    },
    legacy: true
  },
  SEND_EMAIL_COMMUNITY: {
    key: 'SEND_EMAIL_COMMUNITY',
    caption: {
      fr: 'Fonction d\'Envoie de mail aux participants/groups etc...'
    },
    legacy: true
  },
  COMMUNITY_FRONTPAGE: {
    key: 'COMMUNITY_FRONTPAGE',
    caption: {
      fr: 'Permet d\'éditer les page publiques des communauté'
    },
    legacy: true
  },
  DISPLAY_SIDEBAR: {
    key: 'DISPLAY_SIDEBAR',
    caption: {
      fr: 'Affiche la barre de menu de gauche'
    },
    legacy: true
  },
  SAAS_PUBLICATION: {
    key: 'SAAS_PUBLICATION',
    caption: {
      fr: 'Utilise l\'écran de publication Saas'
    },
    legacy: true
  },
  NO_PROFORMAT: {
    key: 'NO_PROFORMAT',
    caption: {
      fr: 'Ne pas afficher les proformats (cas ADIQ)'
    },
    legacy: true
  },
  MODE_PUBLICATION: {
    key: 'MODE_PUBLICATION',
    caption: {
      fr: 'Permet de choisir le mode de publication '
    },
    legacy: true
  },
  RESULT_PPT: {
    key: 'RESULT_PPT',
    caption: {
      fr: 'Nouveau système de resultats - affiche en plus pour l\'instant'
    },
    legacy: true
  },
  RESULT_PPT_PRO: {
    key: 'RESULT_PPT_PRO',
    caption: {
      fr: 'Nouveau système de resultats - version \'PRO\''
    },
    legacy: true
  },
  SURVEY_DETAIL_RESULT_VIEW: {
    key: 'SURVEY_DETAIL_RESULT_VIEW',
    caption: {
      fr: 'Voir un mini tableau de réponses dans les tuiles client.'
    },
    legacy: true
  },
  GET_ALL_EXT_PROFILS: {
    key: 'GET_ALL_EXT_PROFILS',
    caption: {
      fr: 'Avoir accès à tous les ext-profils'
    },
    legacy: true
  },
  ANNOTATION_READ: {
    key: 'ANNOTATION_READ',
    caption: {
      fr: 'Afficher les annotations dans le résultat des questionnaires'
    },
    legacy: true
  },
  ANNOTATION_WRITE: {
    key: 'ANNOTATION_WRITE',
    caption: {
      fr: 'Gérer les annotations des questionnaires'
    },
    legacy: true
  },
  SURVEY_STATS: {
    key: 'SURVEY_STATS',
    caption: {
      fr: 'Afficher les stats de réponse par paritipant dans le rapport Excel'
    },
    legacy: true
  },
  DETAIL_RESPONSES: {
    key: 'DETAIL_RESPONSES',
    caption: {
      fr: 'Afficher le détail des réponses - (Supprimer des réponses, temps etc...)'
    },
    legacy: true
  },
  SAAS_LIST: {
    key: 'SAAS_LIST',
    caption: {
      fr: 'Afficher les comptes associés SAAS - cas de Wagralim'
    },
    legacy: true
  },
  GOD_MODE: {
    key: 'GOD_MODE',
    caption: {
      fr: 'Mode *InbePowerUser*'
    },
    legacy: true
  },
  PUBLIC_LINK: {
    key: 'PUBLIC_LINK',
    caption: {
      fr: 'Voir le lien public dans l\'onglet de publication'
    },
    legacy: true
  },
  MULTI_ANNOTATE: {
    key: 'MULTI_ANNOTATE',
    caption: {
      fr: 'Permet d\'écrire des annotations dans les questionnaires Multi'
    },
    legacy: true
  },
  MULTI_CONDITIONS: {
    key: 'MULTI_CONDITIONS',
    caption: {
      fr: 'Permet de rendre l\'affichage des statements conditionnelles'
    },
    legacy: true
  },
  SHORTCUT_TO_V2: {
    key: 'SHORTCUT_TO_V2',
    caption: {
      fr: 'Permet ajoute un bouton pour accéder à l\'appClient v2'
    },
    legacy: true
  },
  /*
  // V2 :
  */
  V2_PUBLICATION: {
    key: 'V2_PUBLICATION',
    caption: {
      fr: 'Permet d\'avoir accès au nouveau mode de publication dans appClient v2'
    },
    legacy: false
  },
  V2_RESULT_DASHBOARD: {
    key: 'V2_RESULT_DASHBOARD',
    caption: {
      fr: 'Permet d\'accéder à la création de résultat (v2) - client doit avoir [SHORTCUT_TO_V2]'
    },
    legacy: false
  },
  V2_DETAILED_RESPONSES: {
    key: 'V2_DETAILED_RESPONSES',
    caption: {
      fr: 'Permet d\'accéder à l\'écran de réponses détailles dans la nouvelle version'
    },
    legacy: false
  },
  V2_QUALITY_CONTROL: {
    key: 'V2_QUALITY_CONTROL',
    caption: {
      fr: 'Activer le contrôle qualité dans l\'écran de résultats détaillés'
    },
    legacy: false
  },
  V2_QUALITY_CONTROL_AI: {
    key: 'V2_QUALITY_CONTROL_AI',
    caption: {
      fr: 'Activer l\'IA dans le contrôle qualité'
    },
    legacy: false
  },
  V2_SURVEY_DUPLICATION: {
    key: 'V2_SURVEY_DUPLICATION',
    caption: {
      fr: 'Dupliquer un sondage'
    },
    legacy: false
  },
  MANAGE_COMMUNITIES: {
    key: 'MANAGE_COMMUNITIES',
    caption: {
      fr: 'Permettre la gestion de communautés'
    },
    legacy: false
  },
  MANAGE_PROJECTS: {
    key: 'MANAGE_PROJECTS',
    caption: {
      fr: 'Permettre la gestion des projets'
    },
    legacy: false
  },
  MANAGE_PUBLICATIONS: {
    key: 'MANAGE_PUBLICATIONS',
    caption: {
      fr: 'Permettre la gestion des publications'
    },
    legacy: false
  },
  MANAGE_ALL_TEMPLATES: {
    key: 'MANAGE_ALL_TEMPLATES',
    caption: {
      fr: 'Permettre la gestion des templates (tous)'
    },
    legacy: false
  },
  SURVEY_TEMPLATE_ADD: {
    key: 'SURVEY_TEMPLATE_ADD',
    caption: {
      fr: 'Ajouter des templates de survey'
    },
    legacy: false
  },
  CAN_EDIT_SURVEY_DIRECT: {
    key: 'CAN_EDIT_SURVEY_DIRECT',
    caption: {
      fr: '[!] Editer directement le Json d\'un sondage - réservé aux devs!',
    },
    legacy: false
  },
  PUBLICATIONS_GENERATE_LINKS: {
    key: 'PUBLICATIONS_GENERATE_LINKS',
    caption: {
      fr: 'Permet l\'accès à la page de génération de liens vers la publication par lot'
    },
    legacy: false
  },
  SURVEY_MODE_TEST: {
    key: 'SURVEY_MODE_TEST',
    caption: {
      fr: 'Donne le droit de mette les liens avec un mode test',
    },
    legacy: false
  },
  TRANSCRIBE: {
    key: 'TRANSCRIBE',
    caption: {
      fr: 'Accès au module de transcriptions MP3->text',
    },
    legacy: false
  },
  TRANSCRIBE_CHOOSE_ENGINE: {
    key: 'TRANSCRIBE_CHOOSE_ENGINE',
    caption: {
      fr: 'Permet de choisir le moteur de transcription (TransloadIt, AwsDirect, AssemblyAI)',
    },
    legacy: false
  },
  TRANSCRIBE_REGENERATE: {
    key: 'TRANSCRIBE_REGENERATE',
    caption: {
      fr: 'Permet de choisir régénérer le html',
    },
    legacy: false
  },
  doNotEvaluateGodMode: {
    key: 'doNotEvaluateGodMode',
    caption: {
      fr: '[NE PAS SELECTIONNER]',
    },
    legacy: true
  },
  ORG_DASH: {
    key: 'ORG_DASH',
    caption: {
      fr: 'Accès au nouveau système de Dashboard (option d\'édition à part)',
    },
    legacy: false
  },
  ORG_DASH_EDIT: {
    key: 'ORG_DASH_EDIT',
    caption: {
      fr: 'Pouvoir éditer le dashboard Dashboard',
    },
    legacy: false
  },
  ORG_DASH_BACKUP: {
    key: 'ORG_DASH_BACKUP',
    caption: {
      fr: 'Pouvoir effectuer et récupérer des copies de sauvegardes',
    },
    legacy: false
  },
  ORG_DASH_PUBLIC: {
    key: 'ORG_DASH_PUBLIC',
    caption: {
      fr: 'Pouvoir créer des liens publiques',
    },
    legacy: false
  },
  PREVIEW_SURVEY: {
    key: 'PREVIEW_SURVEY',
    caption: {
      fr: 'Prévisualisation d\'un sondage dans la liste',
    },
    legacy: false
  },
  ASK_AI_ASSISTANT: {
    key: 'ASK_AI_ASSISTANT',
    caption: {
      fr: 'Accès à l\'assistant IA et la modification'
    },
    legacy: false
  },
  ASK_AI_THREAD: {
    key: 'ASK_AI_THREAD',
    caption: {
      fr: 'Accès à la gestion des threads IA'
    },
    legacy: false
  },
  ASK_AI_STD_PROMPT: {
    key: 'ASK_AI_STD_PROMPT',
    caption: {
      fr: 'Accès à la gestion des prompts standards'
    },
    legacy: false
  }
};

export function userRolesGetAsKeyValue(): { [key: string]: LocalizedValue } {

  const result: { [key: string]: LocalizedValue } = {};
  Object.keys(userRolesDetails).forEach(aKey => {
    result[aKey] = userRolesDetails[aKey].caption;
  });

  return result;

}

// export const userRoles: any = {
//   SURVEY_IDEA: 'Droit de faire un questionnaire chasse aus id\u00e9es',
//   SURVEY_COMBAT: 'Droit de faire un questionnaire combat d\'id\u00e9es',
//   SURVEY_BENCHMARK: 'Droit de faire un questionnaire de type Benchmark',
//   SURVEY_MULTI: 'Droit de faire un questionnaire de type Multi',
//   SURVEY_KANO: 'Droit de faire un questionnaire de type KANO',
//   SURVEY_EXCEL_EXPORT: 'Droit d\'exporter les r\u00e9sultats en format excel',
//   BLOG_ADD: 'Droit d\'ajouter un article',
//   BLOG_STARS: 'BLOG_STARS',
//   SUPER_USER: 'Droit de faire des super-utilisateur',
//   SUPER_USER_5: '5 super-utilisateur max',
//   CHANGE_USER_LEVEL: 'CHANGE_USER_LEVEL',
//   LOGIN_AS_USER: 'Possibilit\u00e9 de se connecter avec un utilisateur',
//   PROJECT_MONETISATION: 'Droit de mon\u00e9tiser les questionnaires',
//   SURVEY_MONETISATION: 'Affiche l\'ongleut pour param\u00e9trer la mon\u00e9tisation dans un questionnaire (cas Exceldor)',
//   PROJECT_ADD: 'Droit de pouvoir cr\u00e9er d\'autres projets',
//   PROJECT_FILES: 'Explorateur de fichiers',
//   AFFILIATE_RESPONDENT: 'Droits de r\u00e9pondre pour des clients',
//   AFFILIATE_RECRUITMENT: 'Droits de promouvoir une communaut\u00e9 aupr\u00e8s des recruteurs',
//   VIEW_EMAIL: 'Droits de voir les courriels',
//   VIEW_URL_INVITATION: 'Voir les URL d\'invitation d\'un utilisateur du projet courant',
//   VIEW_URL_INVITATION_ALL: 'Voir les URL d\'invitation d\'un utilisateur de TOUS les projets',
//   VIEW_METHO_INBE: 'Voir la methodologie Inbe - astuces et aide en ligne',
//   USECASE: 'Possibilit\u00e9 d\'avoir des cas d\'usage',
//   EXPERT_INTERACTION: 'Possibilit\u00e9 d\'interagir avec les experts (Blogs, appel d\'offre)',
//   CAN_BUY_CREDITS: 'Possibilit\u00e9 d\'acheter des nouveaux cr\u00e9dits (Carte de cr\u00e9dit)',
//   STARTER_ACCOUNT: 'Compte Starter',
//   BASIC_ACCOUNT: 'Compte Basic',
//   PRO_ACCOUNT: 'Compte Pro',
//   PROPLUS_ACCOUNT: 'Compte Pro+',
//   ADVANCEJOINPROJECT: 'Edition avanc\u00e9e des pages de communaut\u00e9',
//   COMMUNITY: 'R\u00f4le communaut\u00e9',
//   COMMUNITY_INTERACTION: 'Emp\u00eache toute interaction avec les participants - email, publication de questionnaire (cas demo).',
//   CAN_PUBLISH: 'Permet de publier (dernier \u00e9cran des questionnaires + nouveau des publications.',
//   PUBLIC_COMMUNITY_CREATION: 'Possibilit\u00e9 de cr\u00e9er des communaut\u00e9s publiques',
//   SEND_EMAIL_COMMUNITY: 'Fonction d\'Envoie de mail aux participants\/groups etc...',
//   COMMUNITY_FRONTPAGE: 'Permet d\'\u00e9diter les page publiques des communaut\u00e9',
//   DISPLAY_SIDEBAR: 'Affiche la barre de menu de gauche',
//   SAAS_PUBLICATION: 'Utilise l\'\u00e9cran de publication Saas',
//   NO_PROFORMAT: 'Ne pas afficher les proformats (cas ADIQ)',
//   MODE_PUBLICATION: 'Permet de choisir le mode de publication ',
//   RESULT_PPT: 'Nouveau syst\u00e8me de resultats - affiche en plus pour l\'instant',
//   RESULT_PPT_PRO: 'Nouveau syst\u00e8me de resultats - version \'PRO\'',
//   SURVEY_DETAIL_RESULT_VIEW: 'Voir un mini tableau de r\u00e9ponses dans les tuiles client.',
//   GET_ALL_EXT_PROFILS: 'Avoir acc\u00e8s \u00e0 tous les ext-profils',
//   ANNOTATION_READ: 'Afficher les annotations dans le r\u00e9sultat des questionnaires',
//   ANNOTATION_WRITE: 'G\u00e9rer les annotations des questionnaires',
//   SURVEY_STATS: 'Afficher les stats de r\u00e9ponse par paritipant dans le rapport Excel',
//   DETAIL_RESPONSES: 'Afficher le d\u00e9tail des r\u00e9ponses - (Supprimer des r\u00e9ponses, temps etc...)',
//   SAAS_LIST: 'Afficher les comptes associ\u00e9s SAAS - cas de Wagralim',
//
//   GOD_MODE: 'Mode *InbePowerUser*',
//
//   PUBLIC_LINK: 'Voir le lien public dans l\'onglet de publication',
//
//   MULTI_ANNOTATE: 'Permet d\'\u00e9crire des annotations dans les questionnaires Multi',
//   MULTI_CONDITIONS: 'Permet de rendre l\'affichage des statements conditionnelles',
//
//   SHORTCUT_TO_V2: 'Permet ajoute un bouton pour acc\u00e9der \u00e0 l\'appClient v2',
//   V2_PUBLICATION: 'Permet d\'avoir acc\u00e8s au nouveau mode de publication dans appClient v2',
//
//   V2_RESULT_DASHBOARD: 'Permet d\'acc\u00e9der \u00e0 la cr\u00e9ation de r\u00e9sultat (v2) - client doit avoir [SHORTCUT_TO_V2]',
//
//   V2_DETAILED_RESPONSES: 'Permet d\'acc\u00e9der \u00e0 l\'\u00e9cran de r\u00e9ponses d\u00e9tailles dans la nouvelle version',
//   V2_QUALITY_CONTROL: 'Activer le contrôle qualité dans l\'écran de résultats détaillés',
//   V2_QUALITY_CONTROL_AI: 'Activer l\'IA dans le contrôle qualité',
//
// };
